'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withMobileDialog = require('./withMobileDialog');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withMobileDialog).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }